<template>
    <f7-page name="policy" >
        <bc-navbar></bc-navbar>   
        <div style="padding:5%;" > 
              <privacy-policy  v-on:goback="back" ></privacy-policy>
        </div>                    
    </f7-page>    

</template>
<script>
import PrivacyPolicy from '../components/privacy-policy'
import TermsOfUse from '../components/terms-of-use'

export default {
  components: {
    'terms-of-use': TermsOfUse,
    'privacy-policy': PrivacyPolicy
  },
  methods: {
    back: function () {
      this.$f7.mainView.router.back()
    }
  }
}
</script>



// WEBPACK FOOTER //
// policy.vue?490571cf